"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LinkTypeEnum;
(function (LinkTypeEnum) {
    LinkTypeEnum["DIRECT"] = "DIRECT";
    LinkTypeEnum["BANNER"] = "BANNER";
    LinkTypeEnum["PROMOTED"] = "PROMOTED";
})(LinkTypeEnum = exports.LinkTypeEnum || (exports.LinkTypeEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGluay10eXBlLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZW51bXMvbGluay10eXBlLmVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxJQUFZLFlBSVg7QUFKRCxXQUFZLFlBQVk7SUFDdEIsaUNBQWlCLENBQUE7SUFDakIsaUNBQWlCLENBQUE7SUFDakIscUNBQXFCLENBQUE7QUFDdkIsQ0FBQyxFQUpXLFlBQVksR0FBWixvQkFBWSxLQUFaLG9CQUFZLFFBSXZCIn0=